import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Container from "react-bootstrap/Container";
import Form from "react-bootstrap/Form";
import Layout from "../Components/Layout/Layout";
import * as Yup from "yup";
import {
  Formik,
  Field,
  ErrorMessage,
  Form as FormikForm,
  FieldArray,
} from "formik";
import { Button, Col, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { addChatBot, addFaq, addPrompt, getChatBot, getFaqById, getPromptById, updateFile } from "../Redux/Actions/event";
import { toast } from "react-toastify";
import { startstopLoading } from "../Redux/Reducers/globalSlice";
import { getBots } from "../Redux/Actions/auth";

const validationSchema = Yup.object({
  question: Yup.string()
    .trim()
    .required("question is required")
    .min(5, "question must be at least 5 characters"),
  answer: Yup.string()
    .trim()
    .required("answer is required")
    .min(20, "answer must be at least 20 characters"),
});


export default function AddPrompt() {

  const currentprompt = useSelector((e) => e.botAuth.promptDetails)

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const id = queryParams.get("id");
  const [loading, setLoading] = useState(false);

  const initialValues = {
    question: id ? currentprompt?.question : "",
    answer: id ? currentprompt?.answer : "",
  };

  const handleSubmit = async (values) => {
    if (id) {
      values['promptId'] = id
    }
    try {
      await dispatch(addPrompt(values)).then((res) => {
        if (res.payload.status == 201 || res.payload.status === 200) {
          // toast.success(res?.payload?.message);
          navigate("/prompts");
        } else {
          setLoading(false);
        }
      });
    } catch (error) {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id) {
      dispatch(startstopLoading(true));
      dispatch(getPromptById({ id })).then(() => {
        dispatch(startstopLoading(false));
      });
    }
  }, [dispatch]);


  return (
    <Layout>
      <Container fluid>
        <div className="filters pb-2">
          <div className="inner-filter-field">
            <div className="image-heading-text">
              <h2>{id ? "Edit" : "Add"} New Prompt</h2>
            </div>
          </div>
          <div className=" new-tabs-add">
            {/* <div className="create-grneral-tab ">
              <p
                className={paramPath === "general" ? "grneral-active" : ""}
                onClick={() => navigate(`/add-new-chatbot?tab=general`)}
              >
                General
              </p>
              <p
                className={paramPath === "limit" ? "grneral-active" : ""}
                onClick={() => navigate(`/add-new-chatbot?tab=limit`)}
              >
                Limits
              </p>
            </div> */}

            <Formik
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={handleSubmit}
              enableReinitialize={true}
            >
              {({
                values,
                setFieldValue,
                setFieldTouched,
                setFieldError,
                handleSubmit,
                errors,
                touched,
              }) => (
                <FormikForm onSubmit={handleSubmit}>
                  <div className="create-notification-page new-tabs-add">
                    <div className="general-heading">
                      <h2>General</h2>
                    </div>

                    <div className="category-field">
                      <div className="general-box">
                        <Row>
                          <Col lg={12}>
                            <div className="modal-input ">
                              <label>Question</label>
                              <Form.Group>
                                <Field
                                  name="question"
                                  type="text"
                                  className="form-control"
                                  placeholder="Enter Here"
                                />
                                <ErrorMessage
                                  name="question"
                                  component="div"
                                  className="text-danger"
                                />
                              </Form.Group>
                            </div>
                          </Col>
                          {/* <Col lg={6}>
                            <div className="modal-input ">
                              <label>Select Chatbot</label>
                              <Form.Group>
                                <Field
                                  as="select"
                                  name="chatbotId"
                                  className="form-control"
                                >
                                  <option value="" disabled>Select Chatbot</option>
                                  {botList?.chatbots?.map((res) => (
                                    <option key={res.chatbotId} value={res.chatbotId}>
                                      {res.name}
                                    </option>
                                  ))}
                                </Field>
                                <ErrorMessage name="chatbotId" component="div" className="text-danger" />
                              </Form.Group>

                            </div>
                          </Col> */}
                          <Col lg={12}>
                            <div className="modal-input mt-3">
                              <label>Answer</label>
                              <Form.Group>
                                <Field
                                  name="answer"
                                  type="text"
                                  className="form-control"
                                  as="textarea"
                                  rows={4}
                                  placeholder="Enter here"
                                />
                                <ErrorMessage
                                  name="answer"
                                  component="div"
                                  className="text-danger"
                                />
                              </Form.Group>
                            </div>
                          </Col>
                        </Row>
                      </div>

                      <div className="create-btn">
                        <button type="submit">Save</button>
                      </div>
                    </div>
                  </div>
                </FormikForm>
              )}
            </Formik>
          </div>
        </div>
        <div className="made-with">
          <div className="pixinvent">
            <p>
              © {new Date().getFullYear()}, Made with ❤️ by{" "}
              <span> Codobux</span>
            </p>
          </div>
        </div>
      </Container>
    </Layout>
  );
}
